import React from 'react'


function dresses(props) {
  return (
    <div>
        <img src={props.img} alt="Ankara-dress" />
    </div>
  )
}

export default dresses